import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {serialize} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {CModule} from 'shared/models/cmodules/cmodule';
import {ICModulesDetailsRepository} from './cmodules-details.repository.interface';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Content } from 'shared/models/contents/content';

@Injectable()
export class CModulesDetailsHttpRepository implements ICModulesDetailsRepository {

  constructor(private http: Http) { }

  public getCModule(id: string): Observable<CModule> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.cmodules}/${id}`, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public getCModules(): Observable<Array<CModule>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.cmodules, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getContents(): Observable<Array<Content>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(environment.contents, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawContents: Array<Content>) => {
        return this.mapToContents(rawContents);
      });
  }

  private mapToContents(rawDialogs: Array<Content>): Array<Content> {
    return rawDialogs.map((rawContent) => {
      return rawContent; //Content.create(rawContent);
    });
  }

  public saveCModule(cmodule: CModule): Observable<CModule> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(cmodule);

    return this.http.post(environment.cmodules, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public updateCModule(cmodule: CModule): Observable<CModule> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(cmodule);

    return this.http.put(`${environment.cmodules}/${cmodule._id}`, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-details/repositories/cmodules-details.repository.http.ts